import type {
  BusquedaRequest,
  BusquedaRefRequest,
  ProductoResponse,
  SugerenciaResponse,
  PrecioResponse,
  ProductoConPrecioResponse,
  ApiResponse,
} from "../types"

const crearHeaders = () => ({
  "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36",
  "Content-Type": "application/json",
})

const isProduction = process.env.NODE_ENV === "production"
const API_BASE_URL = isProduction ? "https://us-central1-mx-vianney-001.cloudfunctions.net" : "/api"

const obtenerPrecioArticulo = async (codigo: string): Promise<number | null> => {
  try {
    const urlPrecio = isProduction
      ? `${API_BASE_URL}/proxyConsultaPrecio/${codigo}`
      : `${API_BASE_URL}/ConsultaPrecioArticulo_USA/${codigo}`
console.log("--->urlCConsultaPrecio: "+ urlPrecio + " API_BASE_URL: " + API_BASE_URL);

    const response = await fetch(urlPrecio, {
      headers: crearHeaders(),
      ...(isProduction && { mode: "cors" as RequestMode }),
    })

    if (!response.ok) {
      console.log("Error al obtener precio:", response.status)
      return null
    }

    const contentPrecio = await response.text()
    console.log("Respuesta API Precio:", contentPrecio)

    const precios: PrecioResponse[] = JSON.parse(contentPrecio)

    // Buscar el precio con IDTARIFAV = 3
    const precioTarifa3 = precios.find((p) => p.IDTARIFAV === 3)

    if (precioTarifa3) {
      console.log("Precio encontrado para tarifa 3:", precioTarifa3.PNETO)
      return precioTarifa3.PNETO
    }

    console.log("No se encontró precio para IDTARIFAV = 3")
    return null
  } catch (error) {
    console.log("Error al obtener precio:", error)
    return null
  }
}

const crearProductoConPrecio = (producto: ProductoResponse, precio: number | null): ProductoConPrecioResponse => {
  const redondearADecimoSuperior = (valor: number) => {
  return (Math.floor(valor * 10) + 1) / 10;
};

  const precioMargen50 = precio ? redondearADecimoSuperior(precio * 1.5) : null;
const precioMargen70 = precio ? redondearADecimoSuperior(precio * 1.7) : null;
const precioMargen100 = precio ? redondearADecimoSuperior(precio * 2.0) : null;

  return {
    Codigo: producto.CodigoFinal,
    Descripcion: producto.DescripcionFinal,
    Precio: precio,
    PrecioFormateado: precio ? `$${precio.toFixed(2)} USD` : "Precio no disponible",
    CodigoFinal: producto.CodigoFinal,
    DescripcionFinal: producto.DescripcionFinal,
    PrecioMargen50: precioMargen50,
    PrecioMargen70: precioMargen70,
    PrecioMargen100: precioMargen100,
    PrecioMargen50Formateado: precioMargen50
      ? precioMargen50.toLocaleString("en-US", { style: "currency", currency: "USD" })
      : "N/A",
    PrecioMargen70Formateado: precioMargen70
      ? precioMargen70.toLocaleString("en-US", { style: "currency", currency: "USD" })
      : "N/A",
    PrecioMargen100Formateado: precioMargen100
      ? precioMargen100.toLocaleString("en-US", { style: "currency", currency: "USD" })
      : "N/A",
  }
}

const procesarProductoResponse = (content: string): ProductoResponse | null => {
  try {
    let producto: ProductoResponse | null = null

    if (content.trim().startsWith("[")) {
      const productosArray: ProductoResponse[] = JSON.parse(content)
      if (productosArray && productosArray.length > 0) {
        producto = productosArray[0]
      }
    } else if (content.trim().startsWith("{")) {
      producto = JSON.parse(content)
    }

    if (producto) {
      // Agregar propiedades finales
      producto.CodigoFinal = producto.codigo || producto.CODIGO || ""
      producto.DescripcionFinal = producto.descripcion || producto.DESCRIPCION || ""
    }

    return producto
  } catch (error) {
    console.log("Error al procesar respuesta del producto:", error)
    return null
  }
}

const procesarSugerenciasResponse = (content: string): SugerenciaResponse[] | null => {
  try {
    let sugerencias: SugerenciaResponse[] | null = null

    if (content.trim().startsWith("[")) {
      sugerencias = JSON.parse(content)
    } else if (content.trim().startsWith("{")) {
      const sugerencia: SugerenciaResponse = JSON.parse(content)
      if (sugerencia) {
        sugerencias = [sugerencia]
      }
    }

    if (sugerencias) {
      // Agregar propiedades finales a cada sugerencia
      sugerencias = sugerencias.map((s) => ({
        ...s,
        RefProveedorFinal: s.refProveedor || s.REFPROVEEDOR || "",
        DescripcionFinal: s.descripcion || s.DESCRIPCION || "",
      }))
    }

    return sugerencias
  } catch (error) {
    console.log("Error al procesar sugerencias:", error)
    return null
  }
}

export const buscarArticulo = async (request: BusquedaRequest): Promise<ApiResponse> => {
  try {
    if (!request.Articulo || request.Articulo.trim() === "") {
      return { success: false, message: "El artículo es requerido" }
    }

    let articulo = request.Articulo.toUpperCase().trim()

    // Si es un código de 5 dígitos, agregar 000 al inicio
    if (/^\d{5}$/.test(articulo)) {
      articulo = "000" + articulo
    }

    // Primera búsqueda por código de barras usando Firebase Function
    const url1 = isProduction
      ? `${API_BASE_URL}/proxyCodigoBarras/${articulo}`
      : `${API_BASE_URL}/codigoBarrasProducto_USA/${articulo}`
console.log("--->urlCodigoBarras: "+ url1  + " API_BASE_URL: " + API_BASE_URL);
    try {
      const response1 = await fetch(url1, {
        headers: crearHeaders(),
        ...(isProduction && { mode: "cors" as RequestMode }),
      })

      if (response1.ok) {
        const content1 = await response1.text()
        console.log("Respuesta API 1:", content1)

        const producto = procesarProductoResponse(content1)

        if (producto && producto.CodigoFinal) {
          const precio = await obtenerPrecioArticulo(producto.CodigoFinal)
          const productoConPrecio = crearProductoConPrecio(producto, precio)

          return {
            success: true,
            tipo: "producto",
            data: productoConPrecio,
          }
        }
      } else {
        console.log("Error HTTP en primera búsqueda:", response1.status)
      }
    } catch (error) {
      console.log("Error en primera búsqueda:", error)
    }

    // Segunda búsqueda por descripción/sugerencias usando Firebase Function
    const url2 = isProduction
      ? `${API_BASE_URL}/proxyBuscarArticulo/${articulo}`
      : `${API_BASE_URL}/BuscarArticulo_USA/${articulo}`
console.log("--->urlBuscarArticulo: "+ url2  + " API_BASE_URL: " + API_BASE_URL);

    try {
      const response2 = await fetch(url2, {
        headers: crearHeaders(),
        ...(isProduction && { mode: "cors" as RequestMode }),
      })

      if (response2.ok) {
        const content2 = await response2.text()
        console.log("Respuesta API 2:", content2)

        const sugerencias = procesarSugerenciasResponse(content2)

        if (sugerencias && sugerencias.length > 0) {
          const sugerenciasMapeadas = sugerencias.map((s) => ({
            RefProveedor: s.RefProveedorFinal,
            Descripcion: s.DescripcionFinal,
            RefProveedorFinal: s.RefProveedorFinal,
            DescripcionFinal: s.DescripcionFinal,
          }))

          return {
            success: true,
            tipo: "sugerencias",
            data: sugerenciasMapeadas,
          }
        }
      } else {
        console.log("Error HTTP en segunda búsqueda:", response2.status)
      }
    } catch (error) {
      console.log("Error en segunda búsqueda:", error)
    }

    return { success: false, message: "Artículo no encontrado" }
  } catch (error) {
    console.log("Error general en búsqueda:", error)
    return { success: false, message: "Error interno del servidor" }
  }
}

export const buscarPorRefProveedor = async (request: BusquedaRefRequest): Promise<ApiResponse> => {
  try {
    if (!request.RefProveedor || request.RefProveedor.trim() === "") {
      return { success: false, message: "La referencia del proveedor es requerida" }
    }

const url = isProduction
      ? `${API_BASE_URL}/proxyCodigoBarras/${request.RefProveedor}`
      : `${API_BASE_URL}/codigoBarrasProducto_USA/${request.RefProveedor}`

      console.log("--->urlCodigoBarras: "+ url  + " API_BASE_URL: " + API_BASE_URL);

    const response = await fetch(url, {
      headers: crearHeaders(),
      ...(isProduction && { mode: "cors" as RequestMode }),
    })

    if (!response.ok) {
      console.log("Error HTTP RefProveedor:", response.status)
      return { success: false, message: "Artículo no encontrado" }
    }

    const content = await response.text()
    console.log("Respuesta API RefProveedor:", content)

    const producto = procesarProductoResponse(content)

    if (producto && producto.CodigoFinal) {
      const precio = await obtenerPrecioArticulo(producto.CodigoFinal)
      const productoConPrecio = crearProductoConPrecio(producto, precio)

      return {
        success: true,
        data: productoConPrecio,
      }
    }

    return { success: false, message: "Artículo no encontrado" }
  } catch (error) {
    console.log("Error en búsqueda por ref proveedor:", error)
    return { success: false, message: "Error interno del servidor" }
  }
}
